import React from 'react'

export const InsureRanceLists = (balanceData) => {
    const InsuranceLifes = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_life"
      )?.expenses_insuarant_lifes;
      const InsuranceAccidents = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_accident"
      )?.expenses_insuarant_accidents;
      const Insurancecars = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_car"
      )?.expenses_insuarant_cars;
      const InsuranceHomes = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_home"
      )?.expenses_insuarant_homes;
      const InsuranceFires = balanceData?.expenses_fixed_list?.find(
        (item) => item?.options_expenses_fixed === "expenses_insuarant_fire"
      )?.expenses_insuarant_fires;

      return {InsuranceLifes,InsuranceAccidents,Insurancecars,InsuranceHomes, InsuranceFires}
}
